import {
    getCurrentProductCode,
    isPluginProduct,
    withPluginProductHeaders,
} from '@common/api/productContext';

export const getProductScopedAuthRequestConfig = () => (
    isPluginProduct(getCurrentProductCode())
        ? withPluginProductHeaders()
        : undefined
);
